export var SlaVersion;
(function (SlaVersion) {
    SlaVersion[SlaVersion["V1"] = 1] = "V1";
    SlaVersion[SlaVersion["V2"] = 2] = "V2";
})(SlaVersion || (SlaVersion = {}));
//# sourceMappingURL=policy-metadata.i.js.map